import { Component, OnInit } from '@angular/core';
import { NzNotificationService } from 'ng-zorro-antd';
import { BsModalRef } from 'ngx-bootstrap';
import { ChangeModeApp, OfflineSalesActionsService } from './offline-sales-actions.service';
@Component({
  selector: 'app-offline-sales-actions',
  templateUrl: './offline-sales-actions.component.html',
  styleUrls: ['./offline-sales-actions.component.css']
})
export class OfflineSalesActionsComponent implements OnInit {
  public areYouSure: string = '¿Estás seguro que quieres activar las ventas ';
  showConfirm: boolean = false;
  textButton: string = 'Activar a en línea';
  intervalValidateApp: any;
  contValidateApp: number = 0;
  showSpinner: boolean = true;
  showError: boolean = false;
  infoUserLogged: any;
  statusAppMode: boolean = true
  textTitle: string = "";
  textSpinner: string = "Cargando...";
  messageResponse = "No se pudo obtener la modalidad de las ventas, inténtelo más tarde.";

  constructor(
    public bsModalRef: BsModalRef,
    private offlineSalesActionsService: OfflineSalesActionsService,
    private notification: NzNotificationService,
  ) { }

  ngOnInit() {
    this.validate();
    this.intervalValidateApp = setInterval(() => {
      if (this.contValidateApp < 3) {
        this.validate();
      }
    }, 10000);
  }
  validate() {
    this.textSpinner = "Cargando...";
    this.messageResponse = 'No se pudo obtener la modalidad de las ventas, inténtelo más tarde.'
    this.showSpinner = true;
    this.showError = false;
    setTimeout(() => {
      this.offlineSalesActionsService.validateModeApp().subscribe((response: any) => {
        this.statusAppMode = response.estatusVenta;
        if (!response.estatusVenta) {
          this.contValidateApp = 4;
          clearInterval(this.intervalValidateApp);
          this.areYouSure = this.areYouSure + 'en línea?';
          this.textButton = 'Activar en línea';
          console.log('VENTA ONLINE');
          this.showSpinner = false;
          this.textTitle = 'Fuera de línea';
        }
        else {
          this.contValidateApp = 4;
          clearInterval(this.intervalValidateApp);
          this.textButton = 'Activar fuera de línea';
          this.areYouSure = this.areYouSure + 'fuera de línea?';
          console.log('VENTA ONLINE');
          this.showSpinner = false;
          this.textTitle = 'En línea';
        }
      }, () => {
        this.contValidateApp++;
        if (this.contValidateApp == 3) {
          this.showError = true;
          clearInterval(this.intervalValidateApp);
          this.showSpinner = false;
          this.createNotification('warning', 'No fue posible obtener la modalidad de las ventas', 'Consulte con el administrador de la aplicación');
        }
      });
    }, 2000);
  }
  changeModeApp() {
    this.textSpinner = "Actualizando...";
    this.showSpinner = true;
    let changeModeApp = new ChangeModeApp();
    this.infoUserLogged = JSON.parse(localStorage.getItem('info_user_logged'));
    this.statusAppMode ? changeModeApp.estatusVenta = false : changeModeApp.estatusVenta = true;
    changeModeApp.idUsuario = (this.infoUserLogged.userAppView.idUserApp).toString();
    this.offlineSalesActionsService.changeModeApp(changeModeApp).subscribe((response: any) => {
      if (response == "INSERTADO CORRECTAMENTE") {
        this.showSpinner = false;
        this.createNotification('success', 'Se actualizó la modalidad de las ventas', 'Todos los usuarios se actualizarán a la nueva modalidad de las ventas');
        setTimeout(() => {
          this.cerrarModal();
        }, 10000);
        this.showError = true;
        this.messageResponse = 'Actualización de la modalidad de las ventas con éxito.';
      }
      else {
        this.showSpinner = false;
        this.createNotification('error', 'No fue posible actualizar la modalidad de las ventas', 'Por favor inténtelo nuevamente.');
        setTimeout(() => {
          this.cerrarModal();
        }, 10000);        this.showError = true;
        this.messageResponse = 'No fue posible actualizar la modalidad de las ventas, por favor inténtelo nuevamente.';
      }
    }, (error) => {
      this.showSpinner = false;
      this.createNotification('error', 'No fue posible actualizar la modalidad de las ventas', 'Por favor inténtelo nuevamente.');
      setTimeout(() => {
        this.cerrarModal();
      }, 10000);      this.showError = true;
      this.messageResponse = 'No fue posible actualizar la modalidad de las ventas, por favor inténtelo nuevamente.';
    });
  }
  cerrarModal() {
    this.bsModalRef.hide();
  }
  confirm(): void {
    this.showConfirm = true;
  }
  createNotification(type: string, title?: string, content?: string): void {
    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.notification.create(
      type,
      title,
      content,
      {
        nzAnimate: true,
      }
    );
  }
}
